<template>
    <v-container fluid>   
      <LeftMenu/>     
        
        <v-tabs
          v-model="tab"
          fixed-tabs          
          background-color="white"
          color="black accent-4"
          left
        >
          <v-tab key="income">
            Income Categories
          </v-tab>
          <v-tab key="expense">
            Expense Categories
          </v-tab>          
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            key="income"
          >
            <v-layout row wrap>   
              <v-flex xs12>&nbsp;</v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersIncome"
                  :items="incomeCategories"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="code"
                  class="elevation-1"
                  :search="search"
                  :custom-filter="filterOnlyCapsText"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Income Categories</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogIncome" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Income Category</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md4>
                                  <v-text-field v-model="editedItem.code" label="Category Code"
                                    :disabled="editedIndex !== -1" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <v-checkbox v-model="editedItem.personnelRelated" label="Personnel Transaction" editedItem.personnelRelated></v-checkbox>
                                </v-flex>  
                                <v-flex xs12 sm6 md4>
                                  <v-checkbox v-model="editedItem.saleRelated" label="Sale Related" editedItem.saleRelated></v-checkbox>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.masterCategory" label="Master Category"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.text" label="Category Name"></v-text-field>
                                </v-flex>                                                                                                                                                                                                                             
                              </v-layout>
                            </v-container>
                          </v-card-text>                      
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeIncome">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="saveIncome">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>   
                  <template v-slot:item.personnelRelated="{ item }">
                    <v-simple-checkbox v-model="item.personnelRelated" disabled></v-simple-checkbox>
                  </template>                       
                  <template v-slot:item.saleRelated="{ item }">
                    <v-simple-checkbox v-model="item.saleRelated" disabled></v-simple-checkbox>
                  </template>     
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editItemIncome(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteItemIncome(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item
            key="expense"
          >
            <v-layout row wrap>   
              <v-flex xs12>&nbsp;</v-flex>
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersExpense"
                  :items="expenseCategories"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="expenseCategory"
                  class="elevation-1"
                  :search="search"
                  :custom-filter="filterOnlyCapsText"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Expense Categories</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogExpense" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Expense Category</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md2>
                                  <v-text-field v-model="editedItem.code" label="Category Code"
                                    :disabled="editedIndex !== -1" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                  <v-checkbox v-model="editedItem.personnelRelated" label="Personnel Transaction" editedItem.personnelRelated></v-checkbox>
                                </v-flex> 
                                <v-flex xs12 sm6 md3>
                                  <v-checkbox v-model="editedItem.purchaseRelated" label="Purchase Related" editedItem.purchaseRelated></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md3>
                                  <v-checkbox v-model="editedItem.budgetDefault" label="Budget Default" editedItem.budgetDefault></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.masterCategory" label="Master Category"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.text" label="Category Name"></v-text-field>
                                </v-flex>   
                                <v-flex xs12 sm6 md12>
                                  <v-combobox
                                    :items="bonusTypeList"
                                    label="Select Bonus Types"
                                    v-model="editedItem.bonusTypes"
                                    item-text="name"
                                    multiple
                                    chips
                                    return-object
                                  ></v-combobox>
                                </v-flex>                                                                                                                                                                      
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeExpense">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>             
                  <template v-slot:item.personnelRelated="{ item }">
                    <v-simple-checkbox v-model="item.personnelRelated" disabled></v-simple-checkbox>
                  </template>  
                  <template v-slot:item.purchaseRelated="{ item }">
                    <v-simple-checkbox v-model="item.purchaseRelated" disabled></v-simple-checkbox>
                  </template>  
                  <template v-slot:item.budgetDefault="{ item }">
                    <v-simple-checkbox v-model="item.budgetDefault" disabled></v-simple-checkbox>
                  </template>  
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editItem(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
        
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const API_URL = 'definitions/expenseCategories';
const INCOME_API_URL = 'definitions/incomeCategories';
const BONUS_TYPES_API_URL = 'definitions/bonusTypes';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {

      tab: null,

      dialogIncome: false,
      dialogExpense: false,
      search: '',
      bonusTypeList: [],
      expenseCategories: [
        {     
          model: '',
          category: '',
          explanation: '',           
        },               
      ],
      incomeCategories: [
        {     
          model: '',
          category: '',
          explanation: '',           
        },               
      ],
      editedIndex: -1,
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
    }
  },
  computed: {
    headersIncome () {
      return [
        { text: 'Category Code', align: 'left', sortable: true, value: 'code' },
        { text: 'Master Category', align: 'left', sortable: true, value: 'masterCategory' },
        { text: 'Category Name',  value: 'text'  },     
        { text: 'Personnel Transaction', align: 'center', value: 'personnelRelated'  },   
        { text: 'Sale Related', align: 'center', value: 'saleRelated'  },  
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    headersExpense () {
      return [
        { text: 'Category Code', align: 'left', sortable: true, value: 'code' },
        { text: 'Master Category', align: 'left', sortable: true, value: 'masterCategory' },
        { text: 'Category Name',  value: 'text'  },     
        { text: 'Personnel Transaction', align: 'center', value: 'personnelRelated'  },     
        { text: 'Purchase Related', align: 'center', value: 'purchaseRelated'  },  
        { text: 'Budget Default', align: 'center', value: 'budgetDefault'  },  
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    formTitle () {
      if(this.tab =='0')
        return this.editedIndex === -1 ? 'New Income Category' : 'Edit Income Category';
      if(this.tab =='1')
        return this.editedIndex === -1 ? 'New Expense Category' : 'Edit Expense Category';
    },
  },
  created() {    
    this.getBonusTypes();
    this.getExpenseCategories();
    this.getIncomeCategories();
  },
  watch: {
    dialogIncome (val) {
      val || this.closeIncome()
    },
    dialogExpense (val) {
      val || this.closeExpense()
    },
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.expenseCategories.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogExpense = true
    },

    deleteItem (item) {
      const index = this.expenseCategories.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.expenseCategories.splice(index, 1);
        this.deleteExpenseCategory(item);
      } 
    },

    editItemIncome (item) {
      this.editedIndex = this.incomeCategories.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogIncome = true
    },

    deleteItemIncome (item) {
      const index = this.incomeCategories.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.incomeCategories.splice(index, 1);
        this.deleteIncomeCategory(item);
      } 
    },

    closeIncome () {
      this.dialogIncome = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    closeExpense () {
      this.dialogExpense = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateExpenseCategory(this.editedItem);
      } else {
        this.addExpenseCategory(this.editedItem);         
      }      
    },    
    addExpenseCategory(item){
      
      var bonusTypes = null;
      if(item.bonusTypes){
        bonusTypes = Array.from(item.bonusTypes,x => x.id);
      }

      this.$axios.post(this.$apiurl + API_URL, {
        id : -1,
        code: item.code,
        masterCategory: item.masterCategory,
        text: item.text,
        personnelRelated : item.personnelRelated,
        purchaseRelated : item.purchaseRelated,
        budgetDefault: item.budgetDefault,
        bonusTypes : bonusTypes
      })
      .then(response => {        
        if (response.status === 201) {
          this.expenseCategories.push(this.editedItem);
          this.closeExpense();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateExpenseCategory(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        code: item.code,
        masterCategory: item.masterCategory,
        personnelRelated : item.personnelRelated,
        purchaseRelated : item.purchaseRelated,
        budgetDefault: item.budgetDefault,
        text: item.text,
        bonusTypes : Array.from(item.bonusTypes,x => x.id)
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.expenseCategories[this.editedIndex], this.editedItem);
          this.closeExpense();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteExpenseCategory(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    
    getExpenseCategories(){     
        this.$axios.get(this.$apiurl + API_URL)
            .then(response => {
                this.expenseCategories = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },

    saveIncome () {
      if (this.editedIndex > -1) {        
        this.updateIncomeCategory(this.editedItem);
      } else {
        this.addIncomeCategory(this.editedItem);         
      }      
    },
    addIncomeCategory(item){

      this.$axios.post(this.$apiurl + INCOME_API_URL, {
        id : -1,
        code: item.code,
        masterCategory: item.masterCategory,
        personnelRelated : item.personnelRelated,
        saleRelated: item.saleRelated,
        text: item.text
      })
      .then(response => {        
        if (response.status === 201) {
          this.incomeCategories.push(this.editedItem);
          this.closeIncome();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateIncomeCategory(item){
      this.$axios.put(this.$apiurl + INCOME_API_URL, {
        id: item.id,
        code: item.code,
        masterCategory: item.masterCategory,
        personnelRelated : item.personnelRelated,
        saleRelated: item.saleRelated,
        text: item.text
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.incomeCategories[this.editedIndex], this.editedItem);
          this.closeIncome();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteIncomeCategory(item){
      this.$axios.delete(this.$apiurl + INCOME_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getIncomeCategories(){     
        this.$axios.get(this.$apiurl + INCOME_API_URL)
            .then(response => {
                this.incomeCategories = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getBonusTypes(){     
        this.$axios.get(this.$apiurl + BONUS_TYPES_API_URL)
            .then(response => {
                this.bonusTypeList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
